import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { downloadFile } from 'utils/helper'
import { notificator } from 'utils/notificator/notificator'
import { IDownloadCSV } from 'utils/types'
import { fileShareDownloadFile } from '../utils/fileShareApi'

export const FileShareDownloadFile = (params: any) => {
  const handelDownload = () => {
    const fileId = params.data.fileExchangeId
    fileShareDownloadFile(fileId)
      .then((res) => {
        if (res) {
          const downloadData: IDownloadCSV = {
            data: res.data,
            fileName: params.data.fileName,
            fileType: 'text/csv',
          }
          downloadFile(downloadData)
        }
      })
      .catch(() => {
        notificator.notify({ type: 'error', heading: 'Unable to download. Please try again later' })
        //notificator.error('Unable to download. Please try again later')
      })
  }

  return (
    <Div>
      <Button onClick={handelDownload} size="small" radius="rounded" variant="primary-outline">
        Download
      </Button>
    </Div>
  )
}

const Div = styled.div``
